module.exports = (angularModule) => angularModule
  .directive('nonGlobalAccountSelection', (accountsService) => {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        accountId: '='
      },
      /**
       * Used ui-select directive because ui-select2 is deprecated--although it seems that ui-select is incredibly buggy and non performant
       * At least it has a cleaner and more composable syntax
       */
      template: () => `
        <ui-select ng-model="selected.account" ng-change="selectionChanged()" theme="select2">
          <ui-select-match placeholder="Select an Account">{{$select.selected.text}}</ui-select-match>
          <ui-select-choices 
                   repeat="account in accounts track by account.id"
                   refresh="query($select)"
                   refresh-delay="0">
                 <div ng-bind-html="account.text | highlight: $select.search"></div>
          </ui-select-choices>
        </ui-select>
       
      `,
      controller: ($scope) => {

        /** get accounts list once **/
        var allAccounts = accountsService.listAccounts().then((res) => res.accounts.map((acc) => {
          return {
            id: acc.id,
            text: acc.accountName,
            upper: acc.accountName.toUpperCase()
          }
        }).sort((a,b) => {
          const upperA = a.upper;
          const upperB = b.upper;
          return (upperA > upperB) ? 1 : (upperA < upperB ? -1 : 0)
        }));

        /** triggered functions **/
        $scope.query = (query) => {
          const term = (query.search || '').toUpperCase();
          allAccounts.then(function (accounts) {
            $scope.accounts = _.filter(accounts, (acc) => acc.upper.indexOf(term) > -1)
          })
        };

        $scope.selectionChanged = () => {
          $scope.accountId = $scope.selected.account.id;
        }

        /** initialize selection **/
        allAccounts.then((accounts) => {
          $scope.accounts = accounts;
          var selection = _.find(accounts, (acc) => acc.id == $scope.accountId);
          $scope.selected = { account: selection };
          $scope.accountId = selection && selection.id; // validate legal account, in case an 'all' slipped in
        });


      }
    }
  });
